export default __webpack_public_path__ + "static/media/sport.bb554b5d.svg";